import config from '@config/seo_meta.json'
import Image from 'next/legacy/image'
import Link from 'next/link'

interface Props {
  slice: any
}

const StockistsEnquiry = ({ slice }: Props) => {
  const { primary } = slice
  const ctaImage: any = primary?.ctaImage
  const title: string = primary?.title
  const description: string = primary?.description
  const link: string = primary?.link
  const linkTitle: string = primary?.linkTitle
  return (
    <div className="bg-brand-white py-16 lg:py-20 ">
      {ctaImage && (
        <div className="block w-full pb-6 lg:hidden">
          <Image
            alt={ctaImage?.alt || config.openGraph.images[0].alt}
            src={ctaImage?.url || '/product-img-placeholder.svg'}
            width={1024}
            height={768}
          />
        </div>
      )}
      <div className="grid lg:grid-cols-2 lg:gap-8">
        <div className="relative">
          <div className="bottom-0 lg:absolute">
            {title && (
              <div className="heading-mobile-4 lg:heading-4 pb-4 lg:pb-6">
                {title}
              </div>
            )}
            {description && (
              <div className="body-1 pb-3 lg:pb-4">{description}</div>
            )}
            {link && (
              <Link
                href={link}
                target={'_blank'}
                className="cursor-pointer underline"
                rel="noreferrer"
              >
                {linkTitle}
              </Link>
            )}
          </div>
        </div>
        {ctaImage && (
          <div className="hidden pb-6 lg:block lg:pb-0">
            <Image
              alt={ctaImage?.alt || config.openGraph.images[0].alt}
              src={ctaImage?.url || '/product-img-placeholder.svg'}
              width={640}
              height={480}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default StockistsEnquiry
